import { FC } from 'react';
import { LMHelpModalLocation, StepInfo } from '../../models';
import './StepModal.css';
import arrow from '../../images/arrow_graphic.svg'


interface StepModalProps {
  stepInfo: StepInfo
  onClick?: () => void
}

const StepModal: FC<StepModalProps> = ({stepInfo, onClick}: StepModalProps) => {
  
  function locationText() {
    switch (stepInfo.modalInfo?.location) {
      case LMHelpModalLocation.Top:
        return 'top'
      case LMHelpModalLocation.Right:
        return 'right'
      case LMHelpModalLocation.Bottom:
        return 'bottom'
      case LMHelpModalLocation.Left:
        return 'left'
      case LMHelpModalLocation.Center:
        return 'center'
    }
  }

  function createMarkup() {
    return {__html: `${stepInfo.description}`};
  }

  return (
    <div className={`StepModalContainer ${locationText()}`}>
      <div className={`StepModal${stepInfo.modalInfo?.isInteractive ? ' interactive' : ''} ${locationText()}`} onClick={onClick ?? (() => {})} >
        {stepInfo.modalInfo?.imagePath &&
          <div 
            className="modalImageContainer" 
            style={{ 
              backgroundImage: `url(${process.env.PUBLIC_URL}${stepInfo.modalInfo?.imagePath})`, 
              backgroundSize: `${stepInfo.modalInfo?.imageSize?.width ?? 0}px ${stepInfo.modalInfo?.imageSize?.height ?? 0}px`, 
              width: `${stepInfo.modalInfo?.imageSize?.width ?? 0}px`, 
              height: `${stepInfo.modalInfo?.imageSize?.height ?? 0}px`,
              marginBottom: '20px'
            }}
          />
        }
        <div className="title">{stepInfo.title}</div>
        {stepInfo.modalInfo?.descriptionUsesHTML ?
          <div className="description" dangerouslySetInnerHTML={createMarkup()}></div>
        : stepInfo.description &&
          <div className="description">{stepInfo.description}</div>
        }
        {(stepInfo.modalInfo?.location !== LMHelpModalLocation.Bottom && stepInfo.modalInfo?.hideArrow !== true) &&
          <div className={`arrowContainer ${locationText()}`} style={{backgroundImage: `url(${arrow})`}}></div>
        }
      </div>
    </div>
  )
};

export default StepModal;
